import React from 'react';
import PropTypes from 'prop-types';
import {
  defineMessages,
  FormattedMessage,
} from 'react-intl';
import classes from './signin-security.scss';
import { AnchorIntl } from 'components/intl';

const t = defineMessages({
  'email-subscription-opt-out.email-subscription': {
    id: 'email-subscription-opt-out.email-subscription',
    defaultMessage: 'Email Subscription',
    description: 'Title string for the Email Subscription section',
  },
  'email-subscription-opt-out.email-subscription-body': {
    id: 'email-subscription-opt-out.email-subscription-body',
    defaultMessage: 'Email updates keep you informed on the latest and greatest products and features.',
    description: 'Body text for the email subscription section',
  },
  'email-subscription-opt-out.opt-out-link': {
    id: 'email-subscription-opt-out.opt-out-link',
    defaultMessage: 'Unsubscribe from email updates',
    description: 'Text for the unsubscribe link',
  },
});

export const EmailSubscriptionOptOut = ({marketingOptOutUrl}) => (
  <div>
    <div className="row">
      <div id="email-subscription-opt-out-title" className="col-xs-12 sectionTitle">
        <FormattedMessage {...t['email-subscription-opt-out.email-subscription']} />
      </div>
    </div>
    <div>
      <div id="email-subscription-opt-out-body" className={classes['sectionInfo']}>
        <FormattedMessage {...t['email-subscription-opt-out.email-subscription-body']} />
      </div>
      <div className={classes['linkLabel']}>
        <AnchorIntl
          a={{
            href: marketingOptOutUrl,
            message: t['email-subscription-opt-out.opt-out-link'],
            target: '_blank'}}
        />
      </div>
    </div>
  </div>
);

EmailSubscriptionOptOut.propTypes = {
  marketingOptOutUrl: PropTypes.string.isRequired,
};

export default EmailSubscriptionOptOut;
